const HolidayOrnamnet = ({ className }: { className?: string }) => (
  <svg
    className={className}
    fill="transparent"
    height="101"
    viewBox="0 0 83 101"
    width="83"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_0_3"
        x1="31.6509"
        x2="51.5095"
        y1="16.7533"
        y2="16.7533"
      >
        <stop stopColor="#772D67" />
        <stop offset="1" stopColor="#89D8FD" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_0_3"
        x1="13.1565"
        x2="70.0111"
        y1="87.3652"
        y2="30.5106"
      >
        <stop offset="0.08" stopColor="#FF6141" />
        <stop offset="0.77" stopColor="#FFCFFC" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_0_3"
        x1="49.8788"
        x2="-2.37065"
        y1="50.1183"
        y2="98.0131"
      >
        <stop stopColor="#89D8FD" />
        <stop offset="0.74" stopColor="#1CB863" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_0_3"
        x1="41.1918"
        x2="41.1918"
        y1="72.0687"
        y2="48.6079"
      >
        <stop offset="0.03" stopColor="#FFCC00" />
        <stop offset="0.36" stopColor="#FF9E26" />
        <stop offset="1" stopColor="#FF6141" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_0_3"
        x1="2.31017"
        x2="25.771"
        y1="60.3383"
        y2="60.3383"
      >
        <stop offset="0.03" stopColor="#FFCC00" />
        <stop offset="0.36" stopColor="#FF9E26" />
        <stop offset="1" stopColor="#FF6141" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint5_linear_0_3"
        x1="56.8576"
        x2="80.3184"
        y1="60.3383"
        y2="60.3383"
      >
        <stop offset="0.03" stopColor="#FFCC00" />
        <stop offset="0.36" stopColor="#FF9E26" />
        <stop offset="1" stopColor="#FF6141" />
      </linearGradient>
    </defs>
    <g id="Group 1311">
      <path
        d="M48.869 13.2017C48.6075 12.5943 48.0085 12.2062 47.3505 12.2062H35.8099C35.1519 12.2062 34.5529 12.5943 34.2914 13.2017L31.7943 18.9889C31.2797 20.1699 32.2583 21.4607 33.5406 21.2835L41.3524 20.1952C41.5043 20.1784 41.6561 20.1784 41.808 20.1952L49.6198 21.2835C50.8937 21.4607 51.8723 20.1699 51.3661 18.9889L48.869 13.2017Z"
        fill="url(#paint0_linear_0_3)"
        id="Vector"
      />
      <path
        clipRule="evenodd"
        d="M33.2659 12.7592C33.7064 11.7371 34.7121 11.0894 35.8099 11.0894H47.3505C48.4483 11.0894 49.454 11.7371 49.8945 12.7592M49.8945 12.7592L52.3927 18.5489C53.2387 20.5231 51.6075 22.6876 49.466 22.3897L41.6721 21.304C41.6107 21.298 41.5497 21.298 41.4883 21.304L33.6947 22.3897C31.5532 22.6856 29.9071 20.5283 30.7695 18.5448C30.7698 18.5441 30.7701 18.5434 30.7704 18.5428L33.2659 12.7592M35.8099 13.3231C35.592 13.3231 35.4 13.4512 35.3172 13.6434L32.8198 19.4314L32.8182 19.435C32.6536 19.8128 32.9651 20.235 33.387 20.1772C33.3873 20.1772 33.3868 20.1773 33.387 20.1772L41.1983 19.0891L41.2291 19.0852C41.4629 19.0592 41.6975 19.0592 41.9313 19.0852L41.9621 19.0891L49.7737 20.1773C49.7738 20.1773 49.7736 20.1773 49.7737 20.1773C50.1794 20.2335 50.5052 19.8174 50.3399 19.4298C50.3398 19.4295 50.3401 19.4301 50.3399 19.4298L47.8435 13.6442C47.7608 13.452 47.5684 13.3231 47.3505 13.3231H35.8099Z"
        fill="#6E3264"
        fillRule="evenodd"
        id="Vector (Stroke)"
      />
      <path
        d="M41.5804 99.1401C63.7859 99.1401 81.7869 81.1391 81.7869 58.9337C81.7869 36.7282 63.7859 18.7272 41.5804 18.7272C19.375 18.7272 1.37395 36.7282 1.37395 58.9337C1.37395 81.1391 19.375 99.1401 41.5804 99.1401Z"
        fill="url(#paint1_linear_0_3)"
        id="Vector_2"
      />
      <path
        clipRule="evenodd"
        d="M41.5804 19.8441C19.9918 19.8441 2.49082 37.3451 2.49082 58.9337C2.49082 80.5223 19.9918 98.0233 41.5804 98.0233C63.169 98.0233 80.67 80.5223 80.67 58.9337C80.67 37.3451 63.169 19.8441 41.5804 19.8441ZM0.25708 58.9337C0.25708 36.1114 18.7582 17.6103 41.5804 17.6103C64.4027 17.6103 82.9038 36.1114 82.9038 58.9337C82.9038 81.7559 64.4027 100.257 41.5804 100.257C18.7582 100.257 0.25708 81.7559 0.25708 58.9337Z"
        fill="#6E3264"
        fillRule="evenodd"
        id="Vector (Stroke)_2"
      />
      <path
        d="M77.392 40.5429C37.059 49.4261 5.83694 40.5682 5.76102 40.5429C0.539067 50.7759 -0.00927962 62.7721 4.10754 73.3847C4.42811 73.469 38.8643 82.2426 79.0539 73.3847C83.1707 62.7805 82.6224 50.7759 77.4004 40.5429H77.392Z"
        fill="url(#paint2_linear_0_3)"
        id="Vector_3"
      />
      <path
        clipRule="evenodd"
        d="M4.76619 40.0353C5.01725 39.5433 5.59022 39.3087 6.1142 39.4834C6.11335 39.4831 6.11807 39.4844 6.12831 39.4872C6.88263 39.6952 37.5997 48.1634 77.1518 39.4522C77.2307 39.4348 77.3112 39.426 77.392 39.426H77.4004C77.8202 39.426 78.2045 39.6614 78.3952 40.0353C83.7631 50.5542 84.326 62.8906 80.0951 73.7889C79.9598 74.1373 79.6593 74.3949 79.2943 74.4754C38.8531 83.3887 4.21584 74.5681 3.82331 74.4648C3.4772 74.3737 3.1957 74.1223 3.06627 73.7886C-1.16452 62.8822 -0.601728 50.5543 4.76619 40.0353ZM76.7864 41.8177C40.5992 49.5922 11.855 43.2417 6.3572 41.8546C1.7389 51.447 1.26912 62.533 4.94321 72.4388C5.20831 72.5014 5.56571 72.5836 6.01101 72.6813C7.04832 72.909 8.5623 73.2212 10.4976 73.5664C14.3686 74.2569 19.9232 75.0796 26.7191 75.6247C40.1814 76.7045 58.491 76.6931 78.2244 72.4227C81.8965 62.516 81.4188 51.4137 76.7864 41.8177Z"
        fill="#6E3264"
        fillRule="evenodd"
        id="Vector (Stroke)_3"
      />
      <path
        clipRule="evenodd"
        d="M41.5805 2.49076C39.4391 2.49076 37.7032 4.22669 37.7032 6.36806C37.7032 8.50944 39.4391 10.2454 41.5805 10.2454C43.7218 10.2454 45.4578 8.50944 45.4578 6.36806C45.4578 4.22669 43.7218 2.49076 41.5805 2.49076ZM35.4694 6.36806C35.4694 2.99303 38.2054 0.257019 41.5805 0.257019C44.9555 0.257019 47.6915 2.99303 47.6915 6.36806C47.6915 9.7431 44.9555 12.4791 41.5805 12.4791C38.2054 12.4791 35.4694 9.7431 35.4694 6.36806Z"
        fill="#6E3264"
        fillRule="evenodd"
        id="Vector (Stroke)_4"
      />
      <g id="Group 1313">
        <path
          d="M41.1918 48.6079L45.4015 56.1245L52.9265 60.3425L45.4015 64.5437L41.1918 72.0687L36.9822 64.5437L29.4657 60.3425L36.9822 56.1245L41.1918 48.6079Z"
          fill="url(#paint3_linear_0_3)"
          id="Vector_4"
        />
        <path
          clipRule="evenodd"
          d="M41.1918 47.491C41.5961 47.491 41.9688 47.7094 42.1663 48.0621L46.2221 55.3041L53.4726 59.3683C53.8254 59.566 54.0437 59.939 54.0433 60.3435C54.043 60.7479 53.824 61.1205 53.4709 61.3177L46.2219 65.3648L42.1666 72.614C41.9691 72.9669 41.5963 73.1856 41.1918 73.1856C40.7874 73.1856 40.4146 72.9669 40.2171 72.614L36.1617 65.3646L28.9207 61.3174C28.5679 61.1202 28.3491 60.7477 28.3488 60.3435C28.3484 59.9392 28.5666 59.5663 28.9191 59.3685L36.1614 55.3044L40.2174 48.0621C40.4149 47.7094 40.7876 47.491 41.1918 47.491ZM41.1918 50.8936L37.9567 56.6702C37.8562 56.8496 37.7081 56.9978 37.5288 57.0984L31.7514 60.3406L37.5271 63.5688C37.7074 63.6695 37.8561 63.8182 37.9569 63.9984L41.1918 69.781L44.4267 63.9984C44.5276 63.8181 44.6766 63.6692 44.857 63.5685L50.6388 60.3406L44.8553 57.0987C44.6758 56.9981 44.5276 56.8498 44.427 56.6702L41.1918 50.8936Z"
          fill="#6E3264"
          fillRule="evenodd"
          id="Vector (Stroke)_5"
        />
        <path
          d="M14.0364 48.6079L18.246 56.1245L25.771 60.3426L18.246 64.5437L14.0364 72.0687L9.82673 64.5437L2.31017 60.3426L9.82673 56.1245L14.0364 48.6079Z"
          fill="url(#paint4_linear_0_3)"
          id="Vector_5"
        />
        <path
          clipRule="evenodd"
          d="M14.0363 47.491C14.4406 47.491 14.8133 47.7095 15.0108 48.0622L19.0666 55.3041L26.3171 59.3683C26.6699 59.566 26.8882 59.9391 26.8878 60.3435C26.8875 60.7479 26.6685 61.1206 26.3154 61.3177L19.0664 65.3648L15.0111 72.614C14.8136 72.967 14.4408 73.1856 14.0363 73.1856C13.6319 73.1856 13.2591 72.967 13.0616 72.614L9.00618 65.3646L1.76526 61.3175C1.41239 61.1202 1.19364 60.7477 1.19329 60.3435C1.19295 59.9392 1.41106 59.5664 1.76359 59.3685L9.00593 55.3044L13.0619 48.0622C13.2594 47.7095 13.6321 47.491 14.0363 47.491ZM14.0363 50.8936L10.8012 56.6702C10.7007 56.8496 10.5526 56.9978 10.3733 57.0985L4.59587 60.3406L10.3716 63.5688C10.5519 63.6695 10.7007 63.8183 10.8015 63.9984L14.0364 69.7811L17.2712 63.9984C17.3721 63.8181 17.5211 63.6693 17.7015 63.5685L23.4833 60.3406L17.6999 57.0987C17.5203 56.9981 17.3721 56.8498 17.2715 56.6702L14.0363 50.8936Z"
          fill="#6E3264"
          fillRule="evenodd"
          id="Vector (Stroke)_6"
        />
        <path
          d="M68.5923 48.6079L72.7934 56.1245L80.3184 60.3425L72.7934 64.5437L68.5923 72.0687L64.3826 64.5437L56.8576 60.3425L64.3826 56.1245L68.5923 48.6079Z"
          fill="url(#paint5_linear_0_3)"
          id="Vector_6"
        />
        <path
          clipRule="evenodd"
          d="M68.5927 47.491C68.9971 47.4912 69.3699 47.71 69.5672 48.063L73.6145 55.3044L80.8645 59.3683C81.2173 59.566 81.4357 59.939 81.4353 60.3435C81.435 60.7479 81.216 61.1205 80.8629 61.3177L73.6143 65.3646L69.5674 72.6131C69.3702 72.9664 68.9973 73.1854 68.5927 73.1856C68.1881 73.1857 67.8151 72.9671 67.6175 72.614L63.5622 65.3648L56.3132 61.3177C55.9601 61.1205 55.7411 60.7479 55.7408 60.3435C55.7404 59.939 55.9587 59.566 56.3115 59.3683L63.562 55.3041L67.6178 48.0621C67.8154 47.7093 68.1883 47.4908 68.5927 47.491ZM68.5913 50.8953L65.3571 56.6702C65.2565 56.8498 65.1083 56.9981 64.9287 57.0987L59.1453 60.3406L64.9271 63.5685C65.1075 63.6692 65.2565 63.8181 65.3574 63.9984L68.5913 69.7793L71.8182 63.9993C71.9191 63.8185 72.0683 63.6694 72.249 63.5685L78.0308 60.3406L72.2473 57.0987C72.0675 56.9979 71.9191 56.8493 71.8185 56.6694L68.5913 50.8953Z"
          fill="#6E3264"
          fillRule="evenodd"
          id="Vector (Stroke)_7"
        />
      </g>
    </g>
  </svg>
)

export default HolidayOrnamnet
